import React from "react";

export function ErrorState({ title = "Something went wrong.", message, retry, testid = "phx-error-state" }) {
  return (
    <div
      data-testid={testid}
      className="border border-[var(--phx-status-danger)]/30 bg-white p-6 rounded-[var(--phx-radius-md)]"
    >
      <p className="text-xs uppercase tracking-[var(--phx-tracking)] font-semibold text-[var(--phx-status-danger)]">
        {title}
      </p>
      {message && (
        <p data-testid={`${testid}-message`} className="mt-3 text-sm text-[var(--phx-slate-700)] leading-relaxed">
          {message}
        </p>
      )}
      {retry && (
        <button
          onClick={retry}
          data-testid={`${testid}-retry`}
          className="mt-4 h-9 px-4 border border-[var(--phx-slate-300)] text-sm font-medium rounded-[var(--phx-radius-md)] hover:bg-[var(--phx-slate-50)]"
        >
          Try again
        </button>
      )}
    </div>
  );
}
